var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0432 15.75C12.5955 15.75 13.0432 16.1977 13.0432 16.75C13.0432 17.3023 12.5955 17.75 12.0432 17.75C11.4911 17.7498 11.0432 17.3021 11.0432 16.75C11.0432 16.1978 11.4911 15.7502 12.0432 15.75Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0432 4.99997C12.4574 4.99997 12.7932 5.34604 12.7932 5.77244V12.9775C12.7932 13.4039 12.4574 13.75 12.0432 13.75C11.6292 13.7498 11.2932 13.4038 11.2932 12.9775V5.77244C11.2932 5.34618 11.6292 5.0002 12.0432 4.99997Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3108 0.999974C11.0806 -0.333301 13.0058 -0.333185 13.7756 0.999974L23.7346 18.25C24.5044 19.5833 23.5418 21.25 22.0022 21.25H2.08424L1.94166 21.2451C0.486335 21.146 -0.393709 19.5416 0.351817 18.25L10.3108 0.999974ZM12.4758 1.74997C12.2833 1.41704 11.8031 1.41693 11.6106 1.74997L1.65065 19C1.45857 19.3331 1.69969 19.7497 2.08424 19.75H22.0022C22.3871 19.75 22.6281 19.3333 22.4358 19L12.4758 1.74997Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.34cb272216cd4ebf253503f7cc36a39c.svg";
export { ForwardRef as ReactComponent };